/**
 * These are essentially a subset of the triggers filters, duplicated here
 * because they are much more narrowly defined.
 */
import { z } from "zod";

export const conversionCustomEventPropertiesFilterGetSchema = z.object({
  filter_key: z.literal("custom_event_properties_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  varies_by_app_group: z.literal(true),
  only_for_workflow_step: z.literal(false),
  comparison_key: z.enum(["1", "2", "3", "4", "5", "6", "10", "11", "12", "15", "16", "17"]),
  display_name: z.string(),
  value: z.union([
    z.boolean(),
    z.number(),
    z.string(),
    z.object({
      value: z.union([z.boolean(), z.number(), z.string()]),
      personalization_type: z.string(),
    }),
  ]),
});

export const conversionOrFilterGetSchema = z.object({
  filter_key: z.literal("or_behavior_condition_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  varies_by_app_group: z.literal(false),
  only_for_workflow_step: z.literal(false),
  comparison_key: z.literal("1"),
  display_name: z.literal(""),
  filters: z.array(conversionCustomEventPropertiesFilterGetSchema),
  value: z.null(),
});

export const conversionFiltersGetSchema = z.array(
  z.discriminatedUnion("filter_key", [conversionCustomEventPropertiesFilterGetSchema, conversionOrFilterGetSchema])
);

/**
 * Nested property filters are offered on ecommerce conversions only, so they are kept out of the
 * schemas above: a purchase or custom event conversion carrying one is a bug worth surfacing.
 */
export const conversionNestedObjectFilterGetSchema = z.object({
  filter_key: z.literal("nested_object_filter"),
  additional_filter_data: z.strictObject({}),
  allowed_for_predictions: z.literal(false),
  allowed_for_territories: z.literal(false),
  comparison_key: z.string().regex(/^\d+-\d+$/), // Matches "1-1", "2-3", etc.
  display_name: z.literal("Nested Property"),
  only_for_workflow_step: z.literal(false),
  value: z.object({
    nested_property_name: z.string().nullable(),
    nested_property_value: z.union([z.boolean(), z.number(), z.string(), z.array(z.string())]),
  }),
  varies_by_app_group: z.literal(false),
});

export const ecommerceConversionOrFilterGetSchema = z.object({
  ...conversionOrFilterGetSchema.shape,
  filters: z.array(
    z.discriminatedUnion("filter_key", [
      conversionCustomEventPropertiesFilterGetSchema,
      conversionNestedObjectFilterGetSchema,
    ])
  ),
});

export const ecommerceConversionFiltersGetSchema = z.array(
  z.discriminatedUnion("filter_key", [
    conversionCustomEventPropertiesFilterGetSchema,
    conversionNestedObjectFilterGetSchema,
    ecommerceConversionOrFilterGetSchema,
  ])
);
